<template>
    <div class="calender-date wrapper d-flex scroll-hide box-shadow">
      <div
        class="date-item hand"
        :class="[selectedDateIndex === i ? 'activeClass' : '']"
        v-for="(item, i) in weekArray"
        :key="i"
        @click="actSelectedDate(item, i)"
      >
        <p class="today" v-if="item.displayName">{{ $t(item.displayName) }}</p>
        <p v-else>{{ item.formattedDate }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CallenderContainer',
    data() {
      return {
        selectedDateIndex: null,
        weekArray: [],
      };
    },
    mounted() {
      this.getWeek();
      this.scheduleMidnightUpdate(); // Auto update after midnight
    },
    methods: {
      formatDisplayDate(date) {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date
          .toLocaleDateString('en-US', options)
          .replace(',', ''); // Remove comma
      },
      formatLocalDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      getWeek() {
        const currentDate = new Date();
        const currentDateStr = this.formatLocalDate(currentDate);
        this.weekArray = [];
  
        // 3 days before today
        for (let i = 3; i > 0; i--) {
          const prevDate = new Date(currentDate);
          prevDate.setDate(currentDate.getDate() - i);
          this.weekArray.push({
            date: this.formatLocalDate(prevDate),
            formattedDate: this.formatDisplayDate(prevDate),
          });
        }
  
        // Today
        this.weekArray.push({
          date: currentDateStr,
          formattedDate: this.formatDisplayDate(currentDate),
          displayName: 'Today',
        });
  
        // 6 days after today
        for (let i = 1; i <= 6; i++) {
          const nextDate = new Date(currentDate);
          nextDate.setDate(currentDate.getDate() + i);
          this.weekArray.push({
            date: this.formatLocalDate(nextDate),
            formattedDate: this.formatDisplayDate(nextDate),
          });
        }
  
        this.selectedDateIndex = this.weekArray.findIndex(item => item.date === currentDateStr);
        // if (this.selectedDateIndex !== -1) {
        //   this.$emit("actSelectDate", this.weekArray[this.selectedDateIndex].date);
        // }
      },
      actSelectedDate(item, index) {
        this.selectedDateIndex = index;
        this.$emit("actSelectDate", item.date);
      },
      scheduleMidnightUpdate() {
        const now = new Date();
        const midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        const msUntilMidnight = midnight.getTime() - now.getTime();
  
        setTimeout(() => {
          this.getWeek();
          this.scheduleMidnightUpdate(); // Reschedule for next day
        }, msUntilMidnight);
      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  .calender-date {
    font-size: 0.9rem;
    text-align: center;
    overflow: auto;
    white-space: nowrap;
    padding: 0.5rem;
  
    .date-item {
      margin: 0.2rem;
      border-radius: 8px;
      // transition: background-color 0.1s, color 0.1s;
      border: 1px solid #ccc;
      background-color: #f9f9f9;
      cursor: pointer;
      min-width: 100px;
      min-width: 100px;
      height: 33px;
      align-content: center;
      text-align: center;
      color: black;
      // &:hover {
      //   background-color: #e6e6e6;
      // }
  
      .today {
        font-weight: bold;
        color: #000;
      }
  
      p {
        margin: 0;
        color: #000;
      }
    }
  
    .activeClass {
      background: linear-gradient(to right, #df6915, #c27321, #b35000);
      color: #ffffff !important;
      border: none;
      p{
        color: #ffffff !important;
      }
    }
  }
  
  @media screen and (min-width: 1024px) {
    .calender-date {
      display: flex;
      width: 100%;
      height: auto;
      align-items: center;
  
      .date-item {
        flex: 1;
        min-width: 110px;
        text-align: center;
      }
    }
  }
  
  .box-shadow {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  </style>
  